import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./motion";

export function ClosingCTA() {
  return (
    <section className="bg-background">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <Reveal y={32}>
          <div className="rounded-[2rem] bg-primary px-8 py-16 text-center shadow-[var(--glow-primary)]">
            <h2 className="mx-auto max-w-2xl text-4xl font-extrabold tracking-tight text-primary-foreground sm:text-[2.7rem]">
              Take an honest look at your money.
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-lg text-primary-foreground/85">
              Your first statement takes about two minutes on the web. Free to start.
            </p>
            <Link
              to="/auth?tab=signup"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-base font-bold text-primary-text transition-transform hover:scale-[1.03] active:scale-[0.98]"
            >
              Get started free <ArrowRight className="h-5 w-5" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
